var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"en-tree-select-board-container"},[_c('div',{staticClass:"tree-select-area"},[_c('en-tree',_vm._g(_vm._b({},'en-tree',_vm.$attrs,false),_vm.$listeners))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }